// NH농협은행 입출금알림(문자알림신청) 등록 안내(2026-07-03 오너 라이브 실측).
// Type A: 6자리 인증번호가 게이트웨이로 수신됨(신한 패턴).
// 농협은 앱이 여러 개라(NH스마트뱅킹·올원뱅크·NH콕뱅크 등) 앱 이름을 못박지 않고 "농협은행 앱"으로 안내.
import type { GuideStep } from './BankRegistrationGuide';
import { GATEWAY_NUMBER_DISPLAY } from './wooriGuide';

export const NONGHYUP_REQUEST_CODE_STEPS: GuideStep[] = [
  {
    title: '농협은행 앱 → 메뉴 → 설정 → 입출금알림 설정',
    detail: 'NH올원뱅크·NH스마트뱅킹·NH콕뱅크 등에서 설정할 수 있어요. 앱에 따라 메뉴 이름·위치가 조금 다를 수 있어요.',
  },
  { title: '문자알림신청 → 알림 받을 입출금 계좌 선택' },
  {
    title: '알림범위 "전체"(또는 "입금"), 금액제한 "제한없음", 알림 받을 시간 "실시간"',
    detail: '금액제한이 "제한없음"이어야 1원 인증 문자를 받을 수 있어요.',
    detailTone: 'danger',
  },
  {
    title: '화면 하단 "알림받을 휴대전화" → "휴대전화 추가"에 아래 셀러헬퍼 번호 입력',
    detail: `내 휴대폰 번호가 아니라 ${GATEWAY_NUMBER_DISPLAY}를 입력해주세요.`,
    detailTone: 'danger',
  },
  { title: '[인증번호 발송]을 누르기' },
];

export const NONGHYUP_COMPLETE_REGISTRATION_STEPS: GuideStep[] = [
  { title: '위에 표시된 6자리 인증번호를 농협은행 앱에 입력' },
  { title: '통지 옵션을 확인하고 신청을 눌러 등록 완료' },
];

export const NONGHYUP_NOTIFY_OPTIONS: GuideStep[] = [
  {
    title: '금액제한: "제한없음"',
    titleTone: 'danger',
    detail: '1원 인증 문자를 받으려면 "제한없음"이어야 해요(금액 지정 금지).',
    detailTone: 'danger',
  },
  { title: '알림범위: "전체" 또는 "입금"' },
  { title: '알림 받을 시간: "실시간"' },
];
